import React from 'react';

type Props = {
  text?: string;
};

const LoaderInline: React.FC<Props> = props => {
  const { text } = props;
  return (
    <div className="LoadingSkeleton">
      <div className="loaderSkeleton" />
      <p>{text || 'Carregando...'}</p>
    </div>
  );
};

export default React.memo(LoaderInline);
